import { useContext } from 'react'

import { StompContext } from '../../containers/StompSessionProvider/StompSessionProvider'
import { StompSessionProviderContextType } from '../../types'

/**
 * Returns the Stomp Client from @stomp/stompjs
 * This will be undefined if the client is currently not connected
 */
function useStompClient() {
  const context = useContext<StompSessionProviderContextType | undefined>(StompContext)

  if (context === undefined)
    throw new Error('There must be a StompSessionProvider as Ancestor of all Stomp Hooks and HOCs')

  return context.client
}

export default useStompClient
